export default __webpack_public_path__ + "static/media/slot3.cb6b86c1.png";